import BaseService from '../../BaseService'
import type { CustomAxiosResponse } from '../../types'
import type { Achievement, Checkin, GroupTask, UserCheckinData, UserTaskData } from '../../types/growth'

class GrowthService extends BaseService {
  /**
   * 获取带分组任务列表
   * @returns 带分组任务列表
   */
  public async getGroupTaskList(): Promise<CustomAxiosResponse<GroupTask[]>> {
    return this.request.get<unknown, CustomAxiosResponse<GroupTask[]>>(`${this.apiUrl}/v1/achievement/app/task/group`)
  }

  /**
   * 领取任务奖励
   * @param id 任务ID
   * @returns null
   */
  public async claimTaskReward(id: number): Promise<CustomAxiosResponse<null>> {
    return this.request.post<unknown, CustomAxiosResponse<null>>(`${this.apiUrl}/v1/achievement/app/task/claim/${id}`)
  }

  /**
   * 获取用户任务数据
   * @returns 用户任务数据
   */
  public async getUserTaskData(): Promise<CustomAxiosResponse<UserTaskData>> {
    return this.request.get<unknown, CustomAxiosResponse<UserTaskData>>(`${this.apiUrl}/v1/achievement/app/task/sum`)
  }

  /**
   * 获取签到列表
   * @returns 签到列表
   */
  public async getCheckinList(): Promise<CustomAxiosResponse<Checkin[]>> {
    return this.request.get<unknown, CustomAxiosResponse<Checkin[]>>(`${this.apiUrl}/v1/achievement/app/check`)
  }

  /**
   * 签到
   * @param id 签到id
   * @returns null
   */
  public async doCheckin(id: number): Promise<CustomAxiosResponse<null>> {
    return this.request.post<unknown, CustomAxiosResponse<null>>(`${this.apiUrl}/v1/achievement/app/check/${id}`)
  }

  /**
   * 获取用户签到数据
   * @returns 用户签到数据
   */
  public async getUserCheckinData(): Promise<CustomAxiosResponse<UserCheckinData>> {
    return this.request.get<unknown, CustomAxiosResponse<UserCheckinData>>(
      `${this.apiUrl}/v1/achievement/app/check/sum`
    )
  }

  /**
   * 获取成就列表
   * @returns 成就列表
   */
  public async getAchievementList(): Promise<CustomAxiosResponse<Achievement[]>> {
    return this.request.get<unknown, CustomAxiosResponse<Achievement[]>>(
      `${this.apiUrl}/v1/achievement/app/user-achievement-record`
    )
  }

  /**
   * 领取成就奖励
   * @param id 成就ID
   */
  public async claimAchievementReward(id: number): Promise<CustomAxiosResponse<null>> {
    return this.request.post<unknown, CustomAxiosResponse<null>>(
      `${this.apiUrl}/v1/achievement/app/user-achievement-record/claim/${id}`
    )
  }
}

export default GrowthService
